import { Icon } from 'components/Icon';
import styled from 'styled-components';

export const RotatedIcon = styled(Icon)`
  transform: rotate(35deg);
  margin-left: 5px;
`;
